import { IColumn, IDetailsHeaderProps, IRenderFunction, Sticky } from '@fluentui/react';

export class GridHelper {
    /** returns a copy of the items array, sorted by the column represented by columnKey */
    static copyAndSort<T>(items: T[], columnKey: string, sortAsString: boolean, isSortedDescending?: boolean): T[] {
        const key = columnKey as keyof T;
        return items.slice(0).sort((a: T, b: T) => {
            let result = 0;
            const aValue = a[key];
            const bValue = b[key];
            if (aValue === undefined || aValue === null) {
                result = 1;
            } else if (bValue === undefined || bValue === null) {
                result = -1;
            } else {
                if (sortAsString) {
                    if (!aValue) {
                        result = 1;
                    } else if (!bValue) {
                        result = -1;
                    } else {
                        // If one value is a string both will, since we're dealing with data in the same
                        // column.
                        result = `${aValue}`.toUpperCase() < `${bValue}`.toUpperCase() ? -1 : 1;
                    }
                } else {
                    result = aValue < bValue ? -1 : 1;
                }
            }

            return isSortedDescending ? -result : result;
        });
    }

    /** returns a new columns collection with properties for sorting set */
    static getNewColumns(
        columns: IColumn[],
        column: IColumn,
        onColumnClickCallback?: (ev: React.MouseEvent<HTMLElement>, column: IColumn) => void
    ) {
        const newColumns: IColumn[] = columns.slice();
        const currColumn: IColumn = newColumns.find((currCol) => column.key === currCol.key)!;
        newColumns.forEach((newCol: IColumn) => {
            if (newCol === currColumn) {
                currColumn.isSortedDescending = !currColumn.isSortedDescending;
                currColumn.isSorted = true;
            } else {
                newCol.isSorted = false;
                newCol.isSortedDescending = true;
            }
            if (onColumnClickCallback) newCol.onColumnClick = onColumnClickCallback;
        });
        return newColumns;
    }

    static getGridDescription = (numberOfRecords: number) => {
        return `Total number of records: ${numberOfRecords}`;
    };

    static StickyHeaderRenderer = (detailsHeaderProps?: IDetailsHeaderProps, defaultRender?: IRenderFunction<IDetailsHeaderProps>) => (
        <Sticky>{defaultRender!(detailsHeaderProps)}</Sticky>
    );
}
